import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery ,Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../components/CustomText";
import GetAppButton from "../../components/GetAppButton";
import { useNavigate } from "react-router-dom";
import more from "../../assets/more.svg";
import acc1_eng from "../../assets/acc1_eng.png"; // Adjust the path as necessary
import acc1_spa from "../../assets/acc1_spa.png"; // Adjust the path as necessary
import {BASE_URL} from "../../components/BASE_URL"
import { useSocialLinks } from "../../components/fetchGetAppUrl";
const HeroSection = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
    const navigate = useNavigate();

    const hero_section_button_text = {
        main: "var(--Tertiary, #003149)",
        hover: "#00263a",
        contrastText: "#FFFFFF",
        fontSize: "18px",
    };

    const handleMore = () => {
        navigate("/product-tour");
    };
  const [loadingExecutive, setLoadingExecutive] = useState(true);
  const [executiveData, setExecutiveData] = useState(null);


useEffect(() => {
  const fetchExecutiveData = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Account_Executive`
      );
      const data = await response.json();
      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];

        // 🔹 Pick EN (idx:0) or ES (idx:1) depending on current language
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        if (item) {
          setExecutiveData({
            title: item.title,
            description: item.description,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching Account Executive data:", error);
    } finally {
      setLoadingExecutive(false);
    }
  };

  fetchExecutiveData();
}, [i18n.language]); // 🔑 re-run whenever language changes
  const { links, } = useSocialLinks();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-between",
                alignItems: "center",
                px: isMobile ? 2 : 8,
                py: isMobile ? 3 : 6,
                backgroundColor: "#F8FFFF",
                gap: isMobile ? 1 : 6,
                marginTop: "70px",
                minHeight: isMobile ? "auto" : "500px",
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    textAlign: { xs: "center", md: "left" },
                    py: { xs: 1, md: 3 },
                }}
            >
                {/* <CustomText
                    style={{
                        ...textStyles.h1,
                        marginBottom: isMobile ? "1rem" : "2rem",
                        marginTop: isMobile ? "0rem" : "1rem",
                        fontSize: isMobile ? "36px" : "52px",
                        textAlign: isMobile ? "center" : "left",
                        color: "#1a365d",
                    }}
                >
                    {t("Account Executive")}
                </CustomText>

                <CustomText
                    style={{
                        ...textStyles.body1,
                        color: "#4a5568",
                        margin: "0 auto",
                        marginTop: "10px",
                        textAlign: isMobile ? "center" : "left",
                        fontSize: isMobile ? "18px" : "24px",
                        lineHeight: 1.6,
                    }}
                >
                    {t("You will be able to sell through your social media channels and will support businesses that have downloaded and registered the app.")}
                </CustomText> */}

                  {loadingExecutive ? (
          <>
            <Skeleton variant="text" width={300} height={50} sx={{ mx: isMobile ? "auto" : 0 }} />
            <Skeleton variant="text" width={500} height={30} sx={{ mx: isMobile ? "auto" : 0 }} />
          </>
        ) : (
          <>
            <CustomText
              style={{
                ...textStyles.h1,
                marginBottom: isMobile ? "1rem" : "2rem",
                marginTop: isMobile ? "0rem" : "1rem",
                fontSize: isMobile ? "36px" : "52px",
                textAlign: isMobile ? "center" : "left",
                color: "#1a365d",
              }}
            >
              {executiveData?.title}
            </CustomText>

            <CustomText
              style={{
                ...textStyles.body1,
                color: "#4a5568",
                margin: "0 auto",
                marginTop: "10px",
                textAlign: isMobile ? "center" : "left",
                fontSize: isMobile ? "18px" : "24px",
                lineHeight: 1.6,
              }}
            >
              {executiveData?.description}
            </CustomText>
          </>
        )}
        

                <Box
                    sx={{
                        display: "flex",
                        flexWrap: isMobile ? "wrap" : "nowrap",
                        justifyContent: isMobile ? "center" : "flex-start",
                        alignItems: "center",
                        mt: isMobile ? "20px" : 4,
                        gap: 2,
                    }}
                >
                    <GetAppButton
                        label={t("Get Started")}
                        variant="primary"
                        size="large"
                    />
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 0,
                            cursor: "pointer",
                        }}
                        onClick={handleMore}
                    >
                        <img
                            src={more || "/placeholder.svg"}
                            style={{ width: "65px", height: "65px" }}
                        />
                        <Typography
                            sx={{
                                color: hero_section_button_text.main,
                                fontSize: "18px",
                                fontWeight: 600,
                                fontFamily: "Poppins, sans-serif",
                            }}
                        >
                            Learn More
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Right Section - Illustration */}
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: { xs: 1, md: 0 },
                    py: 0,
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        height: isMobile ? "auto" : "500px",
                        borderRadius: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                    }}
                >

                    <img
                        src={i18n.language === "es" ? acc1_spa : acc1_eng}
                        alt="Account Executive Illustration"
                        style={{
                            width: "100%",
                            height: isMobile ? "auto" : "100%",
                            objectFit: "contain",
                            borderRadius: "20px",
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default HeroSection;
